<template>
  <div>
    <div>
      <div class="form-row">
        <div style="width: 650px" class="form-row-input">
          <scc-input-validator :rules="[requiredRule]" :value="data.summary"
            @validate="(v) => (this.isSummaryValid = v)">
            <ejs-textbox float-label-type="Always" placeholder="Summary" v-model="data.summary" />
          </scc-input-validator>
        </div>
      </div>

      <div class="form-row">
        <div style="width: 650px" class="form-row-input">
          <scc-input-validator :rules="[requiredRule]" :value="data.description"
            @validate="(v) => (this.isDescriptionValid = v)">
            <ejs-textbox float-label-type="Always" placeholder="Description"
              v-model="data.description" multiline="true" rows=3 />
          </scc-input-validator>
        </div>
      </div>
    </div>
    <div class="form-row">
      <div style="width: 650px" class="align-right">
        <ejs-button type="submit" cssClass="e-info margin-button"
          v-on:click.native="onSubmitNotesClick()">Save</ejs-button>
        <ejs-button type="button" cssClass="e-info margin-button"
          v-on:click.native="onCancelClick()">Cancel</ejs-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import SccInputValidator from '../../../components/base/scc-input-validator.vue';
import { SET_USER_NOTES_BY_ID } from "../store";

Vue.use(TextBoxPlugin);

export default {
  name: 'SaveUserNotes',
  components: {
    SccInputValidator,
  },
  props: {
    userProfileId: String,
    userNote: Object,
  },
  data() {
    return {
      data: {
        summary: null,
        description: null
      },
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      isSummaryValid: false,
      isDescriptionValid: false,
    };
  },
  async mounted() {
    if (this.userNote.id !== null) {
      this.data.summary = this.userNote.summary;
      this.data.description = this.userNote.description;
    }
  },
  methods: {
    notify(type, message) {
      this.$parent.$parent.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$parent.$refs.notifierRef.show();
      }
    },
    validateNotesInfo() {
      this.data.summary = !this.data.summary ? '' : this.data.summary;
      this.data.description = !this.data.description ? '' : this.data.description;
    },
    async onSubmitNotesClick() {
      this.validateNotesInfo();
      const isValid = this.isSummaryValid && this.isDescriptionValid;
      if (isValid) {
        try {
          if (!this.userNote.id) {
            this.userNote.id = '00000000-0000-0000-0000-000000000000';
          }
          const data = { ...this.userNote, ...this.data };
          await this.$store.dispatch(SET_USER_NOTES_BY_ID, { data });
          this.notify('Success!', 'Notes saved successfully.');
          this.$emit('IsNewNoteVal', false);
          this.$emit('RebindGrid', true);
        } catch (err) {
          this.notify('Error', 'Oops! Something went wrong.');
        }
      } else {
        this.notify('Error', 'Please fill out required fields and try again.');
      }
      return isValid;
    },
    onCancelClick() {
      this.$emit('IsNewNoteVal', false);
    },
  },
};
</script>
